import React from 'react';
import ScoreTag from './ScoreTag';
import ScoreTagGroup from './ScoreTagGroup';
import {ProspectPoolTotalScoreRankHistory} from 'api';

type Props = {
  history: ProspectPoolTotalScoreRankHistory;
};

export const ScoreTagSection = ({history}: Props) => {
  const prospectScoreHistoryDetails =
    history.prospectPoolTotalScoreRankProspectStandardItemHistories || [];

  const companyScoreHistoryDetails =
    history.prospectPoolTotalScoreRankAccountStandardItemHistories || [];

  const leadTags = prospectScoreHistoryDetails.map((detail) => ({
    direction: detail.direction,
    text: detail.fieldName,
  }));
  const companyTags = companyScoreHistoryDetails.map((detail) => ({
    direction: detail.direction,
    text: detail.fieldName,
  }));

  return (
    <div
      className={`flex items-stretch gap-2 py-2 px-4 pl-19 border-b border-gray-200 bg-white`}>
      <ScoreTagGroup title="リード">
        {leadTags.map((tag, index) => (
          <ScoreTag key={index} direction={tag.direction}>
            {tag.text}
          </ScoreTag>
        ))}
      </ScoreTagGroup>

      <ScoreTagGroup title="企業">
        {companyTags.map((tag, index) => (
          <ScoreTag key={index} direction={tag.direction}>
            {tag.text}
          </ScoreTag>
        ))}
      </ScoreTagGroup>
    </div>
  );
};
